module.exports = __webpack_public_path__ + "static/media/UpSpell.b6be606c.webp";